export default __webpack_public_path__ + "static/media/chemistry2.c38daef8.png";